// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__pqXVI","actionsCol":"EnrolledClinics_actionsCol__wS-6C"};